import type { Message } from '@norkin/chat-core';
import type { MessageActionRegistry } from '@norkin/chat-react';

function extractPlainText(message: Message): string {
  return message.content
    .filter(part => part.type === 'text')
    .map(part => (part.type === 'text' ? part.text : ''))
    .join('')
    .trim();
}

const hasClipboardSupport = () => typeof navigator !== 'undefined' && !!navigator.clipboard?.writeText;

export function buildDefaultMessageActions(): MessageActionRegistry {
  return ctx => {
    const text = extractPlainText(ctx.message);
    if (!text || !hasClipboardSupport()) {
      return [];
    }

    return [
      {
        id: 'copy-text',
        ariaLabel: 'Copy message text',
        label: 'Copy',
        onClick: async ({ message }) => {
          const value = extractPlainText(message);
          if (!value) return;
          try {
            await navigator.clipboard.writeText(value);
          } catch (error) {
            console.error('[shadcn-chat] Failed to copy message text', error);
          }
        },
      },
    ];
  };
}
